import type { FC } from 'react';
import { IconCheckmarkCircle, IconPanorama360Outline } from '@zillow/constellation';
import { Text, Tooltip, TriggerText } from '@zillow/constellation-10';

import { StyledTourCardImage } from './StyledComponents';

interface TourCardImageProps {
  imageSrc: string | undefined;
  onClick?: () => void | null;
  isHidden?: boolean;
  isSelected?: boolean;
  size?: 'sm' | 'md' | 'full';
}

const TourCardImage: FC<TourCardImageProps> = ({
  imageSrc = '',
  onClick = null,
  isHidden = false,
  isSelected = false,
  size = 'sm',
}) => (
  <StyledTourCardImage
    md={size === 'md'}
    full={size === 'full'}
    clickable={onClick !== null}
    onClick={onClick || (() => {})}
  >
    {isHidden && (
      <div className="TourCardImage-overlay">
        <Tooltip.Root>
          <Tooltip.Trigger>
            <TriggerText css={{ borderBottom: 'initial' }}>Hidden 3D tour</TriggerText>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content>
              <Text>
                Floor plans with units only show 3D tours at the unit level. Please add your 3D tour to individual units
                to have 3D tours show on our sites.
              </Text>
              <Tooltip.Arrow />
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </div>
    )}
    {isSelected && (
      <div className="TourCardImage-selected">
        <IconCheckmarkCircle size="md" fontColor="brand" />
      </div>
    )}
    {imageSrc ? (
      <div className="TourCardImage-container" style={{ backgroundImage: `url(${imageSrc})` }} />
    ) : (
      <div className="TourCardImage-container">
        <IconPanorama360Outline size="lg" fontColor="gray500" />
      </div>
    )}
  </StyledTourCardImage>
);

export type { TourCardImageProps };
export default TourCardImage;
